const DateService = {
    formatDateToLocale: (dateString, locale = 'en-US') => {
        const date = new Date(dateString);
        if (isNaN(date)) {
            console.warn(`Invalid date string: ${dateString}`);
            return null;
        }
        return date.toLocaleString(locale, {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    },

    formatDateCustom: (dateString, includeTime = false, timeOnly = false) => {
        const date = new Date(dateString);
        if (isNaN(date)) {
            console.warn(`Invalid date string: ${dateString}`);
            return null;
        }

        const options = {};

        if (timeOnly) {
            options.hour = '2-digit';
            options.minute = '2-digit';
            options.hour12 = true;
        } else {
            options.day = '2-digit';
            options.month = 'short';
            options.year = 'numeric';
           
            // Add time options if includeTime is true
            if (includeTime) {
                options.hour = '2-digit';
                options.minute = '2-digit';
                options.hour12 = true;
            }
        }

        return date.toLocaleString('en-US', options);
    },

    isValidDate: (dateString) => {
        const date = new Date(dateString);
        return !isNaN(date);
    }
};

export default DateService;
